// import {
//   Alert,
//   Button,
//   IconButton,
//   Snackbar,
//   TextField,
// } from "@mui/material";
// import React, { useEffect, useMemo, useState } from "react";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// import {
//   applyCoupon,
//   fetchAllCoupons,
//   clearCouponState,
// } from "../../../Redux Toolkit/Customer/CouponSlice";

// import LocalOfferIcon from "@mui/icons-material/LocalOffer";
// import { teal } from "@mui/material/colors";
// import FavoriteIcon from "@mui/icons-material/Favorite";

// import CartItemCard from "./CartItemCard";
// import { useNavigate } from "react-router-dom";
// import PricingCard from "./PricingCard";

// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { fetchUserCart } from "../../../Redux Toolkit/Customer/CartSlice";

// import { CartItem } from "../../../types/cartTypes";
// import { Close } from "@mui/icons-material";
// import { trackEvent } from "../../../util/analytics";

// const FREE_SHIPPING_LIMIT = 1499;

// const Cart = () => {
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();

//   const { cart, auth, coupone } = useAppSelector((store) => store);

//   const [couponCode, setCouponCode] = useState("");
//   const [snackbarOpen, setOpenSnackbar] = useState(false);
//   const [showCoupons, setShowCoupons] = useState(true);

//   const cartItemsCount = cart.cart?.cartItems?.length || 0;
//   const totalSellingPrice = cart.cart?.totalSellingPrice || 0;

//   const sortedCartItems = useMemo(() => {
//     return [...(cart.cart?.cartItems || [])].sort((a, b) => a.id - b.id);
//   }, [cart.cart?.cartItems]);

//   useEffect(() => {
//     dispatch(fetchAllCoupons(localStorage.getItem("jwt") || ""));
//   }, [dispatch]);

//   useEffect(() => {
//     trackEvent("CART_VIEW", {
//       page: "/cart",
//     });
//   }, []);

//   useEffect(() => {
//     dispatch(fetchUserCart(localStorage.getItem("jwt") || ""));
//   }, [auth.jwt, dispatch]);

//   const handleChange = (e: any) => {
//     setCouponCode(e.target.value);
//   };

//   const handleApllyCoupon = (apply: string) => {
//     let code = couponCode;

//     if (apply === "false") {
//       code = cart.cart?.couponCode || "";
//     }

//     dispatch(
//       applyCoupon({
//         apply,
//         code,
//         orderValue: cart.cart?.totalSellingPrice || 100,
//         jwt: localStorage.getItem("jwt") || "",
//       })
//     ).then(() => dispatch(fetchUserCart(localStorage.getItem("jwt") || "")));
//   };

//   const handleCloseSnackbar = () => {
//     setOpenSnackbar(false);
//     dispatch(clearCouponState());
//   };

//   useEffect(() => {
//     if (coupone.couponApplied || coupone.error) {
//       setOpenSnackbar(true);
//       setCouponCode("");

//       if (coupone.couponApplied) {
//         dispatch(fetchUserCart(localStorage.getItem("jwt") || ""));
//       }
//     }
//   }, [coupone.couponApplied, coupone.error, dispatch]);

//   return (
//     <>
//       {cart.cart && cart.cart?.cartItems.length !== 0 ? (
//         <div className="px-4 sm:px-8 lg:px-16 xl:px-24 py-6 min-h-screen bg-white">
//           <div className="mb-5">
//             <h1 className="text-2xl font-semibold">
//               Your Cart ({cartItemsCount}{" "}
//               {cartItemsCount === 1 ? "Item" : "Items"})
//             </h1>

//             <p className="text-sm text-gray-600 mt-1">
//               Review your items and proceed to checkout.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//             <div className="lg:col-span-2 space-y-4">
//               <div className="border rounded-md overflow-hidden">
//                 {sortedCartItems.map((item: CartItem, index: number) => (
//                   <CartItemCard
//                     key={item.id}
//                     item={item}
//                     showDivider={index !== sortedCartItems.length - 1}
//                   />
//                 ))}
//               </div>
//             </div>

//             <div className="col-span-1 text-sm space-y-3">

//               <div
//                 onClick={() => navigate("/wishlist")}
//                 className="border rounded-md px-5 py-4 flex justify-between items-center cursor-pointer"
//               >
//                 <span>Add Items From Wishlist</span>

//                 <FavoriteIcon
//                   sx={{
//                     color: teal[600],
//                     fontSize: "21px",
//                   }}
//                 />
//               </div>
//               <section className="border rounded-md">
//                 <PricingCard />

//                 <div className="px-5 pb-5 space-y-4">
//                   <div>
//                     <div className="flex gap-2 text-sm items-center mb-2">
//                       <LocalOfferIcon
//                         sx={{
//                           color: teal[600],
//                           fontSize: "17px",
//                         }}
//                       />

//                       <span className="font-medium">Apply Coupon</span>
//                     </div>

//                     {!cart.cart?.couponCode ? (
//                       <div className="flex gap-2">
//                         <TextField
//                           value={couponCode}
//                           onChange={handleChange}
//                           placeholder="Enter coupon code"
//                           size="small"
//                           fullWidth
//                         />

//                         <Button
//                           onClick={() => handleApllyCoupon("true")}
//                           disabled={!couponCode}
//                           size="small"
//                           variant="contained"
//                           sx={{ px: 3 }}
//                         >
//                           Apply
//                         </Button>
//                       </div>
//                     ) : (
//                       <div className="flex">
//                         <div className="p-1 pl-5 pr-3 border rounded-full flex gap-2 items-center">
//                           <span>{cart.cart.couponCode} Applied</span>

//                           <IconButton
//                             onClick={() => handleApllyCoupon("false")}
//                             size="small"
//                           >
//                             <Close className="text-red-600" />
//                           </IconButton>
//                         </div>
//                       </div>
//                     )}

//                     {!cart.cart?.couponCode && coupone.coupons.length > 0 && (
//                       <div className="mt-4 space-y-2 max-h-[360px] overflow-y-auto pr-1">
//                         <p className="text-sm font-semibold">
//                           Available Coupons
//                         </p>

//                         {coupone.coupons
//                           .filter((coupon) => coupon.active)
//                           .map((coupon) => {
//                             const isEligible =
//                               totalSellingPrice >= coupon.minimumOrderValue;

//                             return (
//                               <div
//                                 key={coupon.id}
//                                 className={`border rounded-md p-3 ${isEligible
//                                   ? "bg-white"
//                                   : "bg-gray-50 opacity-70"
//                                   }`}
//                               >
//                                 <div className="flex justify-between gap-3">
//                                   <div>
//                                     <p className="font-semibold text-sm text-teal-700">
//                                       {coupon.code}
//                                     </p>

//                                     <p className="text-xs text-gray-600">
//                                       Get {coupon.discountPercentage}% off
//                                     </p>

//                                     <p className="text-xs text-gray-500">
//                                       Minimum order ₹
//                                       {coupon.minimumOrderValue}
//                                     </p>
//                                   </div>

//                                   <Button
//                                     size="small"
//                                     variant="outlined"
//                                     disabled={!isEligible}
//                                     onClick={() => {
//                                       setCouponCode(coupon.code);

//                                       dispatch(
//                                         applyCoupon({
//                                           apply: "true",
//                                           code: coupon.code,
//                                           orderValue: totalSellingPrice,
//                                           jwt:
//                                             localStorage.getItem("jwt") || "",
//                                         })
//                                       ).then(() =>
//                                         dispatch(
//                                           fetchUserCart(
//                                             localStorage.getItem("jwt") || ""
//                                           )
//                                         )
//                                       );
//                                     }}
//                                   >
//                                     Apply
//                                   </Button>
//                                 </div>

//                                 {!isEligible && (
//                                   <p className="text-xs text-red-500 mt-2">
//                                     Add ₹
//                                     {coupon.minimumOrderValue -
//                                       totalSellingPrice}{" "}
//                                     more to apply
//                                   </p>
//                                 )}
//                               </div>
//                             );
//                           })}
//                       </div>
//                     )}
//                   </div>

//                   <Button
//                     onClick={() => {
//                       const isFreeShipping =
//                         totalSellingPrice > FREE_SHIPPING_LIMIT;

//                       const shippingFee = isFreeShipping ? 0 : 95;

//                       const finalTotal = totalSellingPrice + shippingFee;

//                       navigate("/checkout/address", {
//                         state: { finalTotal },
//                       });
//                     }}
//                     sx={{ py: "11px" }}
//                     variant="contained"
//                     fullWidth
//                   >
//                     PROCEED TO CHECKOUT
//                   </Button>
//                 </div>
//               </section>
//             </div>
//           </div>
//         </div>
//       ) : (
//         <div className="h-[85vh] flex justify-center items-center flex-col">
//           <div className="text-center py-5">
//             <h1 className="text-lg font-medium">Hey it's feels so light!</h1>

//             <p className="text-gray-500 text-sm">
//               there is nothing in your bag, lets add some items
//             </p>
//           </div>

//           <Button
//             onClick={() => navigate("/wishlist")}
//             variant="outlined"
//             sx={{ py: "11px" }}
//           >
//             Add Item From Wishlist
//           </Button>
//         </div>
//       )}

//       <Snackbar
//         anchorOrigin={{
//           vertical: "top",
//           horizontal: "right",
//         }}
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={coupone.error ? "error" : "success"}
//           variant="filled"
//           sx={{ width: "100%" }}
//         >
//           {coupone.error
//             ? coupone.error
//             : coupone.couponApplied
//               ? "Coupon Applied successfully"
//               : ""}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// export default Cart;



import {
  Alert,
  Button,
  IconButton,
  Snackbar,
  TextField,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import {
  applyCoupon,
  fetchAllCoupons,
  clearCouponState,
} from "../../../Redux Toolkit/Customer/CouponSlice";

import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { teal } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";

import CartItemCard from "./CartItemCard";
import { useNavigate } from "react-router-dom";
import PricingCard from "./PricingCard";

import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import { fetchUserCart } from "../../../Redux Toolkit/Customer/CartSlice";

import { CartItem } from "../../../types/cartTypes";
import { Close } from "@mui/icons-material";
import { trackEvent } from "../../../util/analytics";

const FREE_SHIPPING_LIMIT = 999;

const Cart = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { cart, auth, coupone } = useAppSelector((store) => store);

  const [couponCode, setCouponCode] = useState("");
  const [snackbarOpen, setOpenSnackbar] = useState(false);
  const [showCoupons, setShowCoupons] = useState(true);

  const cartItemsCount = cart.cart?.cartItems?.length || 0;
  const totalSellingPrice = cart.cart?.totalSellingPrice || 0;

  const sortedCartItems = useMemo(() => {
    return [...(cart.cart?.cartItems || [])].sort((a, b) => a.id - b.id);
  }, [cart.cart?.cartItems]);

  useEffect(() => {
    dispatch(fetchAllCoupons(localStorage.getItem("jwt") || ""));
  }, [dispatch]);

  useEffect(() => {
    trackEvent("CART_VIEW", {
      page: "/cart",
    });
  }, []);

  useEffect(() => {
    dispatch(fetchUserCart(localStorage.getItem("jwt") || ""));
  }, [auth.jwt, dispatch]);

  const handleChange = (e: any) => {
    setCouponCode(e.target.value);
  };

  const handleApllyCoupon = (apply: string) => {
    let code = couponCode;

    if (apply === "false") {
      code = cart.cart?.couponCode || "";
    }

    dispatch(
      applyCoupon({
        apply,
        code,
        orderValue: cart.cart?.totalSellingPrice || 100,
        jwt: localStorage.getItem("jwt") || "",
      })
    ).then(() => dispatch(fetchUserCart(localStorage.getItem("jwt") || "")));
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
    dispatch(clearCouponState());
  };

  useEffect(() => {
    if (coupone.couponApplied || coupone.error) {
      setOpenSnackbar(true);
      setCouponCode("");

      if (coupone.couponApplied) {
        dispatch(fetchUserCart(localStorage.getItem("jwt") || ""));
      }
    }
  }, [coupone.couponApplied, coupone.error, dispatch]);

  return (
    <>
      {cart.cart && cart.cart?.cartItems.length !== 0 ? (
        <div className="px-4 sm:px-8 lg:px-16 xl:px-24 py-6 min-h-screen bg-white">
          <div className="mb-5">
            <h1 className="text-2xl font-semibold">
              Your Cart ({cartItemsCount}{" "}
              {cartItemsCount === 1 ? "Item" : "Items"})
            </h1>

            <p className="text-sm text-gray-600 mt-1">
              Review your items and proceed to checkout.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2 space-y-4">
              <div className="border rounded-md overflow-hidden">
                {sortedCartItems.map((item: CartItem, index: number) => (
                  <CartItemCard
                    key={item.id}
                    item={item}
                    showDivider={index !== sortedCartItems.length - 1}
                  />
                ))}
              </div>
            </div>

            <div className="col-span-1 text-sm space-y-3">
              <div
                onClick={() => navigate("/wishlist")}
                className="border rounded-md px-5 py-4 flex justify-between items-center cursor-pointer"
              >
                <span>Add Items From Wishlist</span>

                <FavoriteIcon
                  sx={{
                    color: teal[600],
                    fontSize: "21px",
                  }}
                />
              </div>

              <section className="border rounded-md">
                <PricingCard />

                <div className="px-5 pb-5 space-y-4">
                  <div>
                    <div className="flex gap-2 text-sm items-center mb-2">
                      <LocalOfferIcon
                        sx={{
                          color: teal[600],
                          fontSize: "17px",
                        }}
                      />

                      <span className="font-medium">Apply Coupon</span>
                    </div>

                    {!cart.cart?.couponCode ? (
                      <div className="flex gap-2">
                        <TextField
                          value={couponCode}
                          onChange={handleChange}
                          placeholder="Enter coupon code"
                          size="small"
                          fullWidth
                        />

                        <Button
                          onClick={() => handleApllyCoupon("true")}
                          disabled={!couponCode}
                          size="small"
                          variant="contained"
                          sx={{ px: 3 }}
                        >
                          Apply
                        </Button>
                      </div>
                    ) : (
                      <div className="flex">
                        <div className="p-1 pl-5 pr-3 border rounded-full flex gap-2 items-center">
                          <span>{cart.cart.couponCode} Applied</span>

                          <IconButton
                            onClick={() => handleApllyCoupon("false")}
                            size="small"
                          >
                            <Close className="text-red-600" />
                          </IconButton>
                        </div>
                      </div>
                    )}

                    {!cart.cart?.couponCode && coupone.coupons.length > 0 && (
                      <div className="mt-4 border rounded-md">
                        <button
                          type="button"
                          onClick={() => setShowCoupons((prev) => !prev)}
                          className="w-full px-3 py-3 flex justify-between items-center text-sm font-semibold"
                        >
                          <span>Available Coupons</span>

                          {showCoupons ? (
                            <KeyboardArrowUpIcon fontSize="small" />
                          ) : (
                            <KeyboardArrowDownIcon fontSize="small" />
                          )}
                        </button>

                        {showCoupons && (
                          <div className="space-y-2 max-h-[360px] overflow-y-auto px-3 pb-3">
                            {[...(coupone.coupons || [])]
                              .filter((coupon) => coupon.active)
                              .sort((a, b) => {
                                const aEligible =
                                  totalSellingPrice >= a.minimumOrderValue;

                                const bEligible =
                                  totalSellingPrice >= b.minimumOrderValue;

                                // Eligible coupons first
                                if (aEligible === bEligible) return 0;

                                return aEligible ? -1 : 1;
                              })
                              .map((coupon) => {
                                const isEligible =
                                  totalSellingPrice >=
                                  coupon.minimumOrderValue;

                                return (
                                  <div
                                    key={coupon.id}
                                    className={`border rounded-md p-3 ${isEligible
                                      ? "bg-white"
                                      : "bg-gray-50 opacity-70"
                                      }`}
                                  >
                                    <div className="flex justify-between gap-3">
                                      <div>
                                        <p className="font-semibold text-sm text-teal-700">
                                          {coupon.code}
                                        </p>

                                        <p className="text-xs text-gray-600">
                                          Get ₹{coupon.discountPercentage} off
                                        </p>

                                        <p className="text-xs text-gray-500">
                                          Minimum order ₹
                                          {coupon.minimumOrderValue}
                                        </p>
                                      </div>

                                      <Button
                                        size="small"
                                        variant="contained"
                                        disabled={!isEligible}
                                        sx={{
                                          minWidth: "70px",
                                          height: "32px",
                                          fontSize: "12px",
                                          textTransform: "none",
                                          px: 2,
                                        }}
                                        onClick={() => {
                                          setCouponCode(coupon.code);

                                          dispatch(
                                            applyCoupon({
                                              apply: "true",
                                              code: coupon.code,
                                              orderValue: totalSellingPrice,
                                              jwt:
                                                localStorage.getItem("jwt") ||
                                                "",
                                            })
                                          ).then(() =>
                                            dispatch(
                                              fetchUserCart(
                                                localStorage.getItem("jwt") ||
                                                ""
                                              )
                                            )
                                          );
                                        }}
                                      >
                                        Apply
                                      </Button>
                                    </div>

                                    {!isEligible && (
                                      <p className="text-xs text-red-500 mt-2">
                                        Add ₹
                                        {coupon.minimumOrderValue -
                                          totalSellingPrice}{" "}
                                        more to apply
                                      </p>
                                    )}
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <Button
                    onClick={() => {
                      const isFreeShipping =
                        totalSellingPrice > FREE_SHIPPING_LIMIT;

                      const shippingFee = isFreeShipping ? 0 : 70;

                      const finalTotal = totalSellingPrice + shippingFee;

                      navigate("/checkout/address", {
                        state: { finalTotal },
                      });
                    }}
                    sx={{ py: "11px" }}
                    variant="contained"
                    fullWidth
                  >
                    PROCEED TO CHECKOUT
                  </Button>
                </div>
              </section>
            </div>
          </div>
        </div>
      ) : (
        <div className="h-[85vh] flex justify-center items-center flex-col">
          <div className="text-center py-5">
            <h1 className="text-lg font-medium">Hey it's feels so light!</h1>

            <p className="text-gray-500 text-sm">
              there is nothing in your bag, lets add some items
            </p>
          </div>

          <Button
            onClick={() => navigate("/wishlist")}
            variant="outlined"
            sx={{ py: "11px" }}
          >
            Add Item From Wishlist
          </Button>
        </div>
      )}

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={coupone.error ? "error" : "success"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {coupone.error
            ? coupone.error
            : coupone.couponApplied
              ? "Coupon Applied successfully"
              : ""}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Cart;